<template>
  <div id="app">
	<Header :cid="Cid"></Header>
    <div class="banner"><img src="../assets/images/index_10.png" /></div>
	<div class="idx-1200-box page-1200-box">
       <div class="page-nav-lef">
		   <div class="page-nav-lef-head">{{classInfo.classname}}</div>
		   <ul class="menu-box">
			 <li v-for="(item,index) in classChild" :key="item.id"><a :href="item.linkurl">{{item.classname}}</a> <img src="../assets/images/right.png" /></li> 
		   </ul>
		   <a href=""><img class="contact-pic" src="../assets/images/index_10.png" alt="客服" /></a>
	   </div>
	   <div class="page-rig-conte">
		   <div class="page-rig-conte-head">
			   <p>{{classInfo.classname}}</p>
			   <div class="nav-site">
				  <p>您当前位置：</p>
				   <a href="/index">首页&gt;</a>
				   <a href="">陵园优势</a>
			   </div>
		   </div>
		   <div class="page-rig-conte-bott">
			   <h2>鸿龙寨生态陵园有限公司简介</h2>
			   <p> 安康市鸿龙寨生态陵园是经陕西省民政厅批准建设，汉滨区民政局组织管理，为城乡居民提供骨灰安放、实行有偿服务的经营性墓园，由安康市鸿龙寨生态陵园开发有限责任公司承建并经营。公司成立于2004年，下设生产部、销售部、财务部、人事部、企划部、办公室等六个部门，历时多年的发展，已初具规模。</p>
			   <img src="../assets/images/index_10.png" />
			   <p>  陵园位于江北朱家湾鸿龙山下，园区南侧公路外即为汉滨区殡仪馆，西侧毗邻安康市公益公墓，北环大道穿村而过，交通便捷。为方便广大群众选购福位的需求，公司在城区金州广场和江北办事处设立了销售分公司。陵区坐北朝南，视野开阔，风水极佳。前有数重案山朝山，东西有青龙白虎为左辅右弼，后有玄武靠山千秋永固。</p>
			   <p>  陵园规划总面积一千二百亩，可安放墓位三十万余座，目前已安放五千余座。公司秉承“全心服务，诚信经营”的理念，将陵园建设成为集生态、观光、实用于一体的园林式墓园，为推进安康殡葬改革事业作出应有的贡献。</p>
		   </div>
	   </div>
	</div>
	<Footer :Idx_bott_wxqrcode="idx_bott_wxqrcode" :Idx_bott_logo="idx_bott_logo"  :Classdata="classData" :Copyright="copyright" :Recordno="record_No"></Footer>
  </div>
</template>
   
<script>
import { InfoListApi} from '../api/info_list'
import {getInfoClassIndex } from '../api/info_class'
import { InfoApi } from '../api/info'
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
export default {
 components: {
    Header,
	Footer
  },
  mixins: [Header, Footer],
  data () {
      return {
          bannerData: [],
		  infoData:{},
		  Cid:8,
		  classInfo:{},
		  classChild:[],
		  page:1,
		  limit: 10,
		  total:0,
		  sid:13,
      }
  },
  mounted() {
      const _this = this;
  	  var sid = this.getQueryString('sid');
  	  this.sid = sid==undefined ? this.sid : sid;
  	  console.log(this.sid)
      this.$nextTick(() => {
      })
      getInfoClassIndex(this.Cid).then(res => {
  	  	console.log(res)
  	  	if(res.status==200){
  	  		console.log(111)
  	  		_this.classInfo = res.data.info[0] || {};
  			_this.classChild = res.data.child_list || [];
  	  	}
  	  }).catch(res => {
  	  	_this.$notify({
  	  	  title: 'It works!',
  	  	  type: 'success',
  	  	  message: res,
  	  	  duration: 5000
  	  	})
  	  })  
  	  
  	 this.getData({page:this.page,limit:this.limit,classid:this.sid}); 
  },
  methods: {
    startHacking () {
      this.$notify({
        title: 'It works!',
        type: 'success',
        message: 'We\'ve laid the ground work for you. It\'s time for you to build something epic!',
        duration: 5000
      })
    },
	getData(data){
		var _this = this;
		InfoApi(data).then(res => {
			console.log(res)
			if(res.status==200){
				console.log('info')
				_this.infoData = res.data.list[0] || {};
			}
		}).catch(res => {
			_this.$notify({
			  title: 'It works!',
			  type: 'success',
			  message: res,
			  duration: 5000
			})
		});
	},
  }
}
</script>
  
<style>
#app {
  font-family: Helvetica, sans-serif;
  text-align: center;
}
</style>
<style>
	@import url("/src/assets/style/style.css");
</style>


// WEBPACK FOOTER //
// src/pages/grave_guide.vue